/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */
import * as React from "react";
import {
  ItemsContainer,
  ItemsSection,
  MenuItem,
  NavigationBar,
} from "@nordcloud/gnui";
import { MenuBarLink } from "./MenuItem";

enum MenuIcons {
  customers = "user", // name of the icon in GNUI
}

const items = [
  {
    caption: "Customers",
    icon: MenuIcons.customers,
    route: "/customers",
  },
];

export function MenuBar() {
  return (
    <NavigationBar>
      <ItemsContainer>
        <ItemsSection>
          {items.map((item) => (
            <MenuBarLink key={item.route} route={item.route}>
              <MenuItem caption={item.caption} icon={item.icon} />
            </MenuBarLink>
          ))}
        </ItemsSection>
      </ItemsContainer>
    </NavigationBar>
  );
}
